import {ConfigApi, MultistoreLayoutType} from "../../../../services/Api/types";
import MultistoreBrandListHomePage from "./components/BrandList/MultistoreBrandListHomePage";
import MultistoreWithMapHomePage from "./components/HomeWithMap/New/v2/MultistoreWithMapHomePage";
import StoreUtils from "../../../../services/Store/StoreUtils";
import MultistoreWithMapHomePageOld from "./components/HomeWithMap/Old/MultistoreWithMapHomePageOld";

interface Props {
    config: ConfigApi;
}

const MultistoreHomePage = ({config}: Props) => {
    const layout = StoreUtils.getMultistoreLayoutType(config);

    if (!layout) return <MultistoreWithMapHomePageOld config={config}/>

    if (layout === MultistoreLayoutType.BRAND_LIST) return <MultistoreBrandListHomePage config={config}/>;

    return <MultistoreWithMapHomePage config={config}/>
}

export default MultistoreHomePage;